import { render, staticRenderFns } from "./resourceVacantList.vue?vue&type=template&id=fea80e9e&scoped=true"
import script from "./resourceVacantList.vue?vue&type=script&lang=js"
export * from "./resourceVacantList.vue?vue&type=script&lang=js"
import style0 from "./resourceVacantList.vue?vue&type=style&index=0&id=fea80e9e&prod&lang=scss&scoped=true"
import style1 from "./resourceVacantList.vue?vue&type=style&index=1&id=fea80e9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea80e9e",
  null
  
)

export default component.exports